import { render, staticRenderFns } from "./Locations.vue?vue&type=template&id=3646ec28&scoped=true&"
import script from "./Locations.vue?vue&type=script&lang=ts&"
export * from "./Locations.vue?vue&type=script&lang=ts&"
import style0 from "./Locations.vue?vue&type=style&index=0&id=3646ec28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3646ec28",
  null
  
)

export default component.exports